import { render, staticRenderFns } from "./dataViz.vue?vue&type=template&id=0a8a7e14"
import script from "./dataViz.vue?vue&type=script&lang=js"
export * from "./dataViz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports